<template>
  <Module
    :id="selectionData.conf.id"
    :isLoaded="true"
  >
    <template>
      <div class="shipping">
        <ModuleShippingMain
          :selectionData="selectionData"
        />

        <!-- quantity 1 / single -->
        <slot v-if="selectionData.main.mode && $store.getters.getSelectedQty == $store.getters.getOrderQtySize.single.min">
          <ModuleShippingSingle
            :selectionData="selectionData.single"
          />
        </slot>
        <!-- quantity 1 / single -->
      </div>
    </template>
  </Module>
</template>

<script>
import { logicMixin } from '@/mixins/LogicMixin';
import Module from '@/components/Composer/Module';
import ModuleShippingMain from '@/components/Composer/ModuleShippingMain';
import ModuleShippingSingle from '@/components/Composer/ModuleShippingSingle';

export default {
  name: 'ModuleShipping',
  props: ['selectionData', 'isExpanded', 'moduleId'],
  mixins: [logicMixin],
  components: {
    Module,
    ModuleShippingMain,
    ModuleShippingSingle,
  },
  mounted () {
    // Event listener to check whenever quantity changes in order to select de default mode for the shipping
    this.$root.$on('changedQty', (value) => {
      value = parseInt(value);
      if (value <= this.$store.getters.getOrderQtySize.xs.min) {
        this.selectionData.main.mode = 1;
      }
      this.selectionData.individual.regions.de = value;
      this.selectionData.individual.regions.eu = 0;
      this.selectionData.individual.regions.other = 0;
      this.selectionData.combined.splitting.national.single = value;
      this.selectionData.combined.splitting.national.bulk = 0;
      this.selectionData.combined.splitting.international.single.de = value;
      this.selectionData.combined.splitting.international.single.eu = 0;
      this.selectionData.combined.splitting.international.single.other = 0;
      this.selectionData.combined.splitting.international.bulk.de = 0;
      this.selectionData.combined.splitting.international.bulk.other = 0;
    });
  }
};
</script>

<style lang="scss" scoped>
/**
 * Shipping Module
 *
 * @author juanpablob <m.juanpablob@gmail.com>
 * @desc Shipping's tab content
 * @since 2021-08-17
**/

$component: 'shipping';

.#{$component} {
  &__price {
    flex: 0 0 auto;
    text-align: right;
  }

  /** RESPONSIVENESS **/

  // ——————————————————————————————
  // Max LG
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-lg')) {
  }

  // ——————————————————————————————
  // Max MD
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-md')) {
    @at-root ::v-deep .#{$component}__select select {
      @include rfs($font-size-base * 6, width);
    }
  }

  // ——————————————————————————————
  // Max SM
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-sm')) {
    @at-root ::v-deep .#{$component} {
      &__select select {
        @include rfs($font-size-base * 7, width);
      }

      // Delayed date input
      &__input-date {
        @include rfs(20rem, width);
      }
    }
  }

  // ——————————————————————————————
  // Max XS
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-xs')) {
    @at-root ::v-deep .#{$component} {
      &__select select {
        @include rfs($font-size-base * 7, width);
      }

      // Delayed date input
      &__input-date {
        width: 100%;
      }
    }
  }
}
</style>

<style lang="scss">
// Styles for common options within the shipping modules
#composer .shipping {
  &__option-duplex {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    @include margin-bottom($spacer);
  }

  &__option {
    display: flex;
    flex-grow: 1;

    .form-input__check label {
      display: flex;
    }
  }

  &__icon {
    position: relative;
    display: inline-block;
    flex-shrink: 0;
    @include rfs(1.6rem, flex-basis);
    @include rfs(1.6rem, width);
    @include rfs(1.6rem, height);
    @include margin-right(map-get($spacers, 2));

    &.--has-left-gap {
      @include margin-left(map-get($spacers, 2));
    }

    img,
    svg {
      @include rfs(1.6rem, width);
      @include rfs(1.6rem, height);
      border: 2px solid $white;
      border-radius: 50%;
    }

    img {
      display: block;
      position: absolute;

      &:nth-child(2) {
        @include rfs(- 0.6rem, left);
        z-index: 0;
      }

      &:nth-child(3) {
        @include rfs(- 1.2rem, left);
        z-index: -2;
      }
    }

    svg {
    }
  }

  &__label {
    flex-grow: 1;

    > small {
      display: block;
      color: $ink-lighter;
      @include font-size($font-size-sm);
      line-height: $line-height-base-sm;
    }
  }

  &__price,
  &__select {
    flex-shrink: 0;
  }

  &__additional_info {
    display: block;
    font-size: 0.85rem;           /* Etwas kleiner als Haupttext */
    line-height: 1.25;         /* Spart vertikale Höhe */
    color: #6B7280;            /* Neutrales Graublau statt Neon-Grün */
    margin-top: 2px;
  }

  &__select select {
    @include rfs($font-size-base * 5, width);
  }

  // Delayed date input
  &__input-date {
    @include rfs(12rem, width);
  }

  /** RESPONSIVENESS **/

  // ——————————————————————————————
  // Max LG
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-lg')) {
  }

  // ——————————————————————————————
  // Max MD
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-md')) {
  }

  // ——————————————————————————————
  // Max SM
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-sm')) {
  }

  // ——————————————————————————————
  // Max XS
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-xs')) {
  }
}
</style>
